import { useCallback, useRef } from 'react';
import { Flex, RootScreen } from '@banhala/ui-kit';
import { useReportTTFD } from '../../hooks';
import { ScreensResult, ScreensAnalyticsProvider } from '../../components';
import { FilterListAtomicProvider } from 'shared/src/component';
import {
  useInstanceId,
  useNativeScrollSync,
  useNativeScrollToTop,
} from 'shared/src/hooks';
import type { AtomicRendererRefCurrent } from '../../components/types';

export const FragmentScreens = () => {
  useReportTTFD();

  const instanceId = useInstanceId();

  const listRef = useRef<AtomicRendererRefCurrent>(null);

  const {
    onScroll: onScrollSync,
    onScrollBeginDrag: onScrollBeginDragSync,
    onScrollEndDrag: onScrollEndDragSync,
  } = useNativeScrollSync({ instanceId });

  useNativeScrollToTop({
    onScrollToTop: useCallback(() => {
      listRef.current?.scrollToOffset({ offset: 0, animated: true });
    }, []),
  });

  return (
    <ScreensAnalyticsProvider>
      <RootScreen>
        <Flex flex={1}>
          <FilterListAtomicProvider>
            <ScreensResult
              listRef={listRef}
              onScrollY={onScrollSync}
              onBeginDrag={onScrollBeginDragSync}
              onEndDrag={onScrollEndDragSync}
            />
          </FilterListAtomicProvider>
        </Flex>
      </RootScreen>
    </ScreensAnalyticsProvider>
  );
};
